import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Loader } from '@design-system/loader';
import { useProperty } from '../hooks/useProperty';
export const Content = forwardRef((_a, inputRef) => {
    var { children, isLoading, isSmall, parentId, pb, property = 'modal-body', pt, viewportRef } = _a, props = __rest(_a, ["children", "isLoading", "isSmall", "parentId", "pb", "property", "pt", "viewportRef"]);
    const ref = useRef(null);
    const loadingRef = useRef(null);
    useProperty(isLoading ? loadingRef : ref, 'dialog', parentId, property);
    useImperativeHandle(inputRef, () => (isLoading ? loadingRef.current : ref.current), [ref, loadingRef, isLoading]);
    return (_jsx(ContentStyled, Object.assign({ "$isLoading": isLoading, ref: viewportRef }, props, { minHeight: isLoading ? '102px' : props.minHeight || 'auto', children: isLoading ? (_jsx(LoaderStyled, { ref: loadingRef, children: _jsx(Loader, { size: 72 }) })) : (_jsx(Box, { display: "block", height: isSmall ? '100%' : 'auto', pb: pb, pt: pt, ref: ref, width: "100%", children: children })) })));
});
const LoaderStyled = styled(Box).attrs({
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '100%',
    pb: 6,
}) ``;
const ContentStyled = styled(Box).attrs(({ $isLoading }) => (Object.assign(Object.assign({}, (!$isLoading && { display: 'block' })), { overflowY: 'auto' }))) `
  grid-area: modal-body;
  transition: min-height 0.2s;
`;
//# sourceMappingURL=Content.js.map